<template>
  <v-menu v-model="menu" offset-y left :max-width="220" :max-height="400">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>account_circle</v-icon>
      </v-btn>
    </template>

    <v-card width="200px">
      <v-list dense id="HeaderBarMenu">
        <v-list-tile @click="goToAccountPage('tab-1')">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $vuetify.t('$vuetify.account.accountInfo') }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="goToAccountPage('tab-2')">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $vuetify.t('$vuetify.account.orderHistory') }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="goToAccountPage('tab-3')">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $vuetify.t('$vuetify.account.paymentMethods') }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider/>

        <v-list-tile @click="logout">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ $vuetify.t('$vuetify.common.logout') }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
        menu: false
      }
    },
    computed: {
      storeId() {
        return this.getStore.storeId || null
      },
      groupId() {
        return this.getStore.groupId || null
      },

      ...mapGetters([ 'getStore' ])
    },

    methods: {
      goToAccountPage(tab) {
        const dineInOnly = this.$route.query.dineInOnly;
        const tid = this.$route.query.tid;
        
        const queryObj = { tab };
        if (dineInOnly) queryObj.dineInOnly = dineInOnly;
        if (tid) queryObj.tid = tid;
        
        this.$router.push({
          name: 'store-account',
          params: {
            gid: this.getStore.groupId,
            sid: this.getStore.storeId
          },
          query: queryObj
        }).catch(error => { console.log(error)});
      },

      logout() {
        this.$store.dispatch('logoutAuthUser')
        this.$store.dispatch('logout')
        this.$store.dispatch('resetCart')

        this.$store.dispatch('fetchShoppingCart')
        const vc = this.$route.query.vc;
        const dineInOnly = this.$route.query.dineInOnly;
        const tid = this.$route.query.tid;
        const mid = this.$route.params.mid;

        const queryObj = {};
        if (vc) queryObj.vc = vc;
        if (dineInOnly) queryObj.dineInOnly = dineInOnly;
        if (tid) queryObj.tid = tid;

        this.$router.push({
          name: 'store',
          params: {
            gid: this.getStore.groupId,
            sid: this.getStore.storeId,
            mid: mid || (this.menu && this.menu.code) || (this.getStore.rootMenu && this.getStore.rootMenu.code),
            restaurantSlug: this.getStore.slug
          },
          query: queryObj
        }).catch(() => {})
      },

      removeParam(key) {
        let query = Object.assign({}, this.$route.query);
        delete query[key];
        this.$router.replace({ query }).catch(() => {})
      }
    }
  }
</script>

<style>
  #HeaderBarMenu .v-list__tile__title {
    font-size: var(--text-size-1);
  }
</style>
